export const coffeeData = [
  {
    name: "Coffee",
    price: "$20.00",
    desc: "A small river named Duden flows by their place and supplies",
    id: "coffee1",
    imgPath: "assets/images/food/dessert-1.jpg.webp"
  },
  {
    name: "Coffee",
    price: "$29.00",
    id: "coffee2",
    desc: "A small river named Duden flows by their place and supplies",
    imgPath: "assets/images/food/dessert-2.jpg.webp"
  },
  {
    name: "Coffee",
    price: "$20.00",
    id: "coffee3",
    desc: "A small river named Duden flows by their place and supplies",
    imgPath: "assets/images/food/dessert-3.jpg.webp"
  },
  {
    name: "Coffee",
    price: "$20.00",
    id: "coffee4",
    desc: "A small river named Duden flows by their place and supplies",
    imgPath: "assets/images/food/dessert-4.jpg.webp"
  },
]
